import { ApolloError, TypedDocumentNode, useSuspenseQuery } from '@apollo/client';
import { Interval, toDate } from 'date-fns';
import {
  BatteryDeviceAcceptedForecastsQuery,
  BatteryDeviceAcceptedForecastsQueryVariables,
  DatapointCollection,
} from 'generated/graphql';
import gql from 'graphql-tag';

const batteryDeviceAcceptedForecastsQuery: TypedDocumentNode<
  BatteryDeviceAcceptedForecastsQuery,
  BatteryDeviceAcceptedForecastsQueryVariables
> = gql`
  query BatteryDeviceAcceptedForecasts($deviceNumbers: [ID!]!, $interval: IntervalInput!) {
    batteryDeviceAcceptedForecasts(deviceNumbers: $deviceNumbers, interval: $interval) {
      type
      resolution
      entityType
      timeSlices {
        timestamp
        entities {
          number
          datapoints {
            type
            value
          }
        }
      }
    }
  }
`;

export function useBatteryDeviceAcceptedForecasts(
  deviceNumbers: readonly string[],
  interval: Interval,
): [DatapointCollection | undefined, ApolloError | undefined] {
  const { data, error } = useSuspenseQuery(batteryDeviceAcceptedForecastsQuery, {
    variables: {
      deviceNumbers,
      interval: {
        start: toDate(interval.start),
        end: toDate(interval.end),
      },
    },
    errorPolicy: 'all',
  });

  return [data?.batteryDeviceAcceptedForecasts, error];
}
